import React, { useEffect, useState } from 'react';
import { api } from '../../api/client';
import { useT } from '../../i18n';

export default function AdminUsers() {
  const t = useT();
  const [users, setUsers] = useState([]);

  useEffect(() => {
    api.get('/api/admin/users').then(setUsers).catch(() => {});
  }, []);

  return (
    <div className="admin-page">
      <h1 className="page-title">{t.adminUsers}</h1>
      <div className="admin-table-wrap">
        <table className="admin-table">
          <thead>
            <tr>
              <th>{t.adminUserName}</th>
              <th>{t.email}</th>
              <th>{t.adminUserRole}</th>
              <th>{t.adminUserDate}</th>
            </tr>
          </thead>
          <tbody>
            {users.map(u => (
              <tr key={u._id}>
                <td>{u.nameAr || '—'}</td>
                <td>{u.email}</td>
                <td><span className={`admin-role-badge role-${u.role}`}>{u.role}</span></td>
                <td>{new Date(u.createdAt).toLocaleDateString('ar')}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
